import { useState } from 'react';
import Layout from '../../components/feature/Layout';
import FunnelVisual from './components/FunnelVisual';
import { DropOffChart, CompareChart } from './components/FunnelCharts';
import FunnelTable from './components/FunnelTable';

const cities = ['Tüm Şehirler', 'İstanbul', 'Ankara', 'İzmir', 'Bursa', 'Antalya'];
const sources = ['Tüm Kaynaklar', 'Google Ads', 'Instagram', 'Facebook', 'Organik', 'TikTok'];
const devices = ['Tüm Cihazlar', 'Mobil', 'Masaüstü', 'Tablet'];

export default function FunnelAnalysis() {
  const [compareMode, setCompareMode] = useState(false);
  const [selectedCity, setSelectedCity] = useState('Tüm Şehirler');
  const [selectedSource, setSelectedSource] = useState('Tüm Kaynaklar');
  const [selectedDevice, setSelectedDevice] = useState('Tüm Cihazlar');
  const [selectedCampaign, setSelectedCampaign] = useState('Tüm Kampanyalar');

  return (
    <Layout>
      <div className="space-y-5">
        {/* Filters Bar */}
        <div className="bg-white rounded-2xl shadow-card p-5">
          <div className="flex flex-wrap gap-3 items-center justify-between">
            <div className="flex flex-wrap gap-3">
              <button className="flex items-center gap-2 h-[38px] px-4 bg-[#FAF8F4] border border-border rounded-xl text-[13px] text-charcoal-500 hover:border-champagne-400 transition-colors cursor-pointer whitespace-nowrap">
                <div className="w-4 h-4 flex items-center justify-center"><i className="ri-calendar-line text-champagne-500 text-[14px]" /></div>
                10 Mar — 17 Mar 2026
              </button>
              <select value={selectedCampaign} onChange={e => setSelectedCampaign(e.target.value)} className="h-[38px] px-3 bg-[#FAF8F4] border border-border rounded-xl text-[13px] text-charcoal-500 focus:outline-none focus:border-champagne-400 cursor-pointer">
                <option>Tüm Kampanyalar</option>
                <option>Botoks &amp; Dolgu Paketi</option>
                <option>Lazer Epilasyon 6 Seans</option>
                <option>Dermapen Cilt Yenileme</option>
              </select>
              <select value={selectedSource} onChange={e => setSelectedSource(e.target.value)} className="h-[38px] px-3 bg-[#FAF8F4] border border-border rounded-xl text-[13px] text-charcoal-500 focus:outline-none focus:border-champagne-400 cursor-pointer">
                {sources.map(s => <option key={s}>{s}</option>)}
              </select>
              <select value={selectedDevice} onChange={e => setSelectedDevice(e.target.value)} className="h-[38px] px-3 bg-[#FAF8F4] border border-border rounded-xl text-[13px] text-charcoal-500 focus:outline-none focus:border-champagne-400 cursor-pointer">
                {devices.map(d => <option key={d}>{d}</option>)}
              </select>
              <select value={selectedCity} onChange={e => setSelectedCity(e.target.value)} className="h-[38px] px-3 bg-[#FAF8F4] border border-border rounded-xl text-[13px] text-charcoal-500 focus:outline-none focus:border-champagne-400 cursor-pointer">
                {cities.map(c => <option key={c}>{c}</option>)}
              </select>
            </div>
            <button
              onClick={() => setCompareMode(!compareMode)}
              className={`flex items-center gap-2 h-[38px] px-4 rounded-xl text-[13px] font-medium transition-colors cursor-pointer whitespace-nowrap border
                ${compareMode ? 'bg-champagne-500 text-white border-champagne-500' : 'bg-[#FAF8F4] text-charcoal-500 border-border hover:border-champagne-400'}
              `}
            >
              <div className="w-4 h-4 flex items-center justify-center"><i className={`ri-git-compare-line text-[14px]`} /></div>
              Karşılaştırma Modu
            </button>
          </div>
        </div>

        {/* Main Funnel Visual */}
        <FunnelVisual compareMode={compareMode} />

        {/* Charts Row */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
          <DropOffChart />
          <CompareChart />
        </div>

        {/* Campaign-Level Table */}
        <FunnelTable />
      </div>
    </Layout>
  );
}
